import { render, staticRenderFns } from "./Editpsw.vue?vue&type=template&id=0491fe24&scoped=true&"
import script from "./Editpsw.vue?vue&type=script&lang=js&"
export * from "./Editpsw.vue?vue&type=script&lang=js&"
import style0 from "./Editpsw.vue?vue&type=style&index=0&id=0491fe24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0491fe24",
  null
  
)

export default component.exports